
const m = window.require("embercom/models/data/matching-system/matching-constants");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
